import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["INVOICE_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["INVOICE_MODULE"],
  },
];

export default routes;
